import _ from 'lodash';
import { SET_ACTIVE_GROUP_ID } from '../../room';
import ReducerRegistry from '../redux/ReducerRegistry';
import { ADD_LOCAL_MEMBER, ADD_MEMBER, ADD_RECORD, DELETE_MEMBER, DELETE_RECORD, LEFT_MEMBER, REMOVE_MEMBERS, SET_BRIDGE_ID, SET_MEMBER_VOICE, SET_SPEAKER_ID, UPDATE_MEMBER, } from './actionType';
import { MEMBER_STATUS, ROLE } from './constans';
import { checkRoleLevel } from './functions';
const DEFAULT_STATE = {
    local: '',
    remote: new Set(),
    pinIds: new Set(),
    recordIds: new Set(),
    voice: '',
    members: new Map(),
    memberIds: new Map(),
    bridgeList: new Map(),
    speakerId: '',
};
// ★성능(운영 부하 감사 R2): 과거에는 모든 액션에서 전체 상태를 _.cloneDeep 했다 —
// 70-80명 방에서는 앱의 "모든" redux 액션(채팅/트랙/타이머 포함)이 멤버 Map 전체 딥클론
// 비용(O(N))을 지불해 입장 러시 시 메인스레드가 정지했다(O(N²)). 케이스별 표적 불변
// 업데이트로 전환: 만지는 컬렉션만 얕은 복사하고, 저장하는 member 객체는 항상 새 객체로
// 절연한다. 미처리 액션은 동일 참조(state)를 반환해 불필요 재렌더도 제거된다.
ReducerRegistry.register('features/base/members', (state = DEFAULT_STATE, action) => {
    let member;
    switch (action.type) {
        case ADD_LOCAL_MEMBER: {
            member = action.member;
            const members = new Map(state.members);
            members.set(member.user_uuid, { ...member });
            const memberIds = new Map(state.memberIds);
            memberIds.set(member.member_uuid, member.user_uuid);
            let pinIds = state.pinIds;
            if (member.pinned && !checkRoleLevel(member.role, ROLE.MANAGER)) {
                pinIds = new Set(state.pinIds);
                pinIds.add(member.user_uuid);
            }
            return {
                ...state,
                local: member.user_uuid,
                members,
                memberIds,
                pinIds,
            };
        }
        case ADD_MEMBER: {
            // member 객체를 action에서 가져옴
            member = action.member;
            // permission 속성을 제외한 새로운 member 객체 생성
            const { permissions, ...memberWithoutPermissions } = member;
            let pinIds = state.pinIds;
            if (member.pinned && !checkRoleLevel(member.role, ROLE.MANAGER)) {
                pinIds = new Set(state.pinIds);
                pinIds.add(memberWithoutPermissions.user_uuid);
            }
            const remote = new Set(state.remote);
            remote.add(memberWithoutPermissions.user_uuid);
            const members = new Map(state.members);
            members.set(memberWithoutPermissions.user_uuid, memberWithoutPermissions);
            const memberIds = new Map(state.memberIds);
            memberIds.set(memberWithoutPermissions.member_uuid, memberWithoutPermissions.user_uuid);
            let bridgeList = state.bridgeList;
            if (memberWithoutPermissions.bridge_sessions && memberWithoutPermissions.bridge_sessions.length > 0) {
                bridgeList = new Map(state.bridgeList);
                bridgeList.set(memberWithoutPermissions.user_uuid, memberWithoutPermissions.bridge_sessions[0]);
            }
            return {
                ...state,
                pinIds,
                remote,
                members,
                memberIds,
                bridgeList,
            };
        }
        case LEFT_MEMBER: {
            member = action.member;
            const members = new Map(state.members);
            members.set(member.user_uuid, { ...member, status: MEMBER_STATUS.VACATED });
            const bridgeList = new Map(state.bridgeList);
            bridgeList.delete(member.user_uuid);
            const pinIds = new Set(state.pinIds);
            pinIds.delete(member.user_uuid);
            return {
                ...state,
                ...(member.local ? { local: '' } : {}),
                members,
                bridgeList,
                pinIds,
                voice: state.voice === member.user_uuid ? '' : state.voice,
            };
        }
        case DELETE_MEMBER: {
            member = action.member;
            const pinIds = new Set(state.pinIds);
            pinIds.delete(member.user_uuid);
            return {
                ...state,
                ...(member.local ? { local: '' } : {}),
                pinIds,
                voice: state.voice === member.user_uuid ? '' : state.voice,
            };
        }
        case ADD_RECORD: {
            const recordIds = new Set(state.recordIds);
            recordIds.add(action.user_uuid);
            return {
                ...state,
                recordIds,
            };
        }
        case DELETE_RECORD: {
            const recordIds = new Set(state.recordIds);
            recordIds.delete(action.user_uuid);
            return {
                ...state,
                recordIds,
            };
        }
        case SET_ACTIVE_GROUP_ID:
            return {
                ...state,
                pinIds: new Set(),
                recordIds: new Set(),
            };
        case UPDATE_MEMBER: {
            member = action.member;
            if (!member.user_uuid)
                break;
            const members = new Map(state.members);
            members.set(member.user_uuid, { ...member });
            const memberIds = new Map(state.memberIds);
            memberIds.set(member.member_uuid, member.user_uuid);
            let pinIds = state.pinIds;
            if (!checkRoleLevel(member.role, ROLE.MANAGER)) {
                pinIds = new Set(state.pinIds);
                if (member.pinned)
                    pinIds.add(member.user_uuid);
                else
                    pinIds.delete(member.user_uuid);
            }
            return {
                ...state,
                members,
                memberIds,
                pinIds,
            };
        }
        case SET_BRIDGE_ID: {
            // 동일 세션 재전송은 무시 — 불필요한 상태 교체/구독자 알림 차단
            const prev = state.bridgeList.get(action.user_uuid);
            if (prev === action.bridge_sessions || _.isEqual(prev, action.bridge_sessions))
                return state;
            const bridgeList = new Map(state.bridgeList);
            bridgeList.set(action.user_uuid, action.bridge_sessions);
            return {
                ...state,
                bridgeList,
            };
        }
        case SET_MEMBER_VOICE:
            if (action.user_uuid) {
                return {
                    ...state,
                    voice: action.user_uuid,
                };
            }
            return state;
        case SET_SPEAKER_ID:
            return {
                ...state,
                speakerId: action.user_uuid,
            };
        case REMOVE_MEMBERS:
            // ★DEFAULT_STATE 의 Map/Set 인스턴스를 재사용하면 초기 상태가 오염된다(공유 참조) — 반드시 새 인스턴스
            return {
                ...state,
                pinIds: new Set(),
                members: new Map(),
                memberIds: new Map(),
                bridgeList: new Map(),
            };
    }
    return state;
});
// declare var APP: any;
// StateListenerRegistry.register((state: any) => getLocalGroup(state),
//     throttle((result, store) => {
//         const isJoined = isRoomJoined(store.getState);
//         if (!isJoined) return;
//         if (result.group_id && result.start === undefined) return;
//         const active_group = getActiveGroupId(store.getState);
//         const { group_id, group_role, start, role } = result;
//         if (role === ROLE.HOST) return;
//         if (start) {
//             if (group_id ) {
//                 if (active_group === group_id) store.dispatch(toggleLoad(false));
//                 else  APP.management.changeManagement(active_group, {group_id, group_role})
//             }
//         } else {
//             if (active_group !== '') {
//                 APP.management.changeManagement(group_id, {group_id: ''});
//             }
//         }
//     }, 1000, { leading: false, trailing: true }), {
//         deepEquals: true
//     }
// )
